<template>
	<div>
		<!-- logo 时间 -->
		<q-head></q-head>
		<!-- banner -->
		<qBanner></qBanner>




		<div class="read">
			<div class="read-hd">
				<q-title title="住院预缴" :time="time" @remain-time="remainTime"></q-title>
				<q-step :step="3"></q-step>
			</div>


			<div class="read-bd-title fc"><i></i>
				<h3>住院信息</h3>
			</div>


			<div>
				
			
			
				<!-- 住院信息 -->
				<div class="k-box b1">
					<div class="hospitalInformation">

						<div class="info">
							<div class="fc-bet">
								<div>
									<span class="tit">住院号码：</span><b>******</b>
								</div>
								<div>
									<span class="tit">费用总额：</span><b style="color:#FF1111;">0.00元</b>
								</div>
							</div>
							<div class="fc-bet">
								<div>
									<span class="tit">姓名：</span><b>张三</b>
								</div>
								<div>
									<span class="tit">预缴金额：</span><b style="color:#FF1111;">0.00元</b>
								</div>
							</div>
							<div class="fc-bet">
								<div>
									<span class="tit">性质：</span><b>自费</b>
								</div>
								<div>
									<span class="tit">剩余金额：</span><b style="color:#FF1111;">8888.00元</b>
								</div>
							</div>
						</div>
						
						<div class="number" @click="showKeyboard=true">
							{{number || '请输入缴费金额'}}
						</div>
						<!-- <input type="text" name="" id="" v-model="number" class="number" placeholder="" disabled="disabled" />
						 -->
						
						<div class="speed-money fc-bet">
							<a v-for="(item,index) in speedNumArr" :key="index" @click="speedNumber(item,index)" :class="{on:index==speedNumArrIndex}">
								{{item}}￥
							</a>
							
						</div>


					</div>
				</div>





				<div class="read-bd-title fc"><i></i>
					<h3>请选择支付方式</h3>
				</div>

				<div class="k-box">
					<div class="fc-bet pay-select xs">
						<a class="pay-item fcc" @click="payClick(1)">
							<div class="icon"><img src="../../assets/pay-alipay2.png"></div>
							<p>
								支付宝支付
							</p>
						</a>
						<a class="pay-item fcc" @click="payClick(2)">
							<div class="icon">
								<img src="../../assets/pay-weixin2.png">
							</div>
							<p>
								微信支付
							</p>
						</a>
					</div>
				</div>



				<div class="foot-buttons fc-bet">
					<a href="/" class="btn-home fcc">
						<img src="../../assets/icon/icon-home.png">
						<span>首页</span>
					</a>

					<a class="btn-return fcc" @click="returnStep()">
						<img src="../../assets/icon/icon-return.png">
						<span>返回</span>
					</a>
				</div>
			
			</div>
		</div>
		
		<!-- 微信支付 -->
		
		<div class="pay-weixin-box" v-if="showPayPop">
			<div class="user-info-row fcc">
				<div>
					<span>姓名：</span>
					<b>张三</b>
				</div>
				<div>
					<span>性别：</span>
					<b>男</b>
				</div>
				<div>
					<span>门诊号码：</span>
					<b>95271</b>
				</div>
			</div>
			<div class="h1">
				请扫描屏幕中间二维码，付款成功后请耐心等候！
			</div>
			<div class="pay-body">
				<div class="img">
					<img src="../../assets/pay-weixin-eg.jpg"  v-if="payStyle==2">
					<img src="../../assets/pay-alipay-eg.jpg" v-if="payStyle==1">
				</div>
				
				<div class="txt">
					<p>本次支付金额为</p>
					<div class="money">
						3541.65元
					</div>
					<div class="code">
						<img src="../../assets/pay-code.png" >
					</div>
					<p class="tips">
						{{payTime}}秒后自动关闭
					</p>
					
					<button type="button" class="btn-cancle" @click="cancle">
						取消交易
					</button>
					
				</div>
			</div>
			<div class="tips-box">
				<h4>温馨提示：</h4>
				<p>
					1、按照左边的图示步骤进行操作；<br>
					2、扫二维码支付成功后请耐心等待，取走缴费凭条；<br>
					3、更换支付方式，请点【取消交易】按钮；
				</p>
			</div>
		</div>
		
		
		
		<!-- 缴费键盘 -->
		<qKeyNumber v-if="showKeyboard" @keyInputNumber="keyInputNumber"></qKeyNumber>
		
	</div>
</template>

<script>
	import qHead from '@/components/q-head/q-head.vue';
	import qBanner from '@/components/q-head/q-banner.vue';
	import qTitle from '@/components/q-read/q-title.vue';
	import qStep from '@/components/q-read/q-step.vue';
	import qKeyNumber from '@/components/q-keyboard/q-number.vue';
	export default {
		components: {
			qHead,
			qBanner,
			qStep,
			qTitle,
			qKeyNumber
		},
		data() {
			return {
				number:null,
				speedNumArr:[
					500,1000,2000,3000,5000
				],
				speedNumArrIndex:null,

				time:86,
				// 支付方式
				showPayPop:false,
				payStyle:1  ,//1支付宝 。2微信
				//支付剩余时间
				payTime:60,
				
				showKeyboard:false
			}
		},
		mounted() {

		},
		methods: {
			speedNumber(item,index){
				this.number=item
				this.speedNumArrIndex=index
			},
			
			payClick(i){
				this.time=60
				this.showPayPop=true
				this.payStyle=i
				
			},
			remainTime(data){
				this.payTime=data
			},	
			cancle(){
				this.time=86
				this.showPayPop=false
				this.payStyle=1
			}
			,keyInputNumber(data){
				this.number=data
				console.log("键盘输入的值",data)
				this.showKeyboard=false
			}
			
		},
		beforeDestroy() {
			//clearInterval(this.timer);
		}

	}
</script>

<style scoped lang="less">

</style>
